import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetWidgetAnalysisConfig } from "@/api/widget/useWidgetAPI";
import { RootState } from "@/store";
import { WidgetConfig } from "@/types/widget";
import { mapPostWidgetAnalysisConfigPayload } from "@/utils/widget";

export default function useDatasetWidgetSummary(widget: WidgetConfig) {
  const { filters } = useSelector((state: RootState) => state.dataset);

  const lastIndex = widget.widget_id.lastIndexOf("_");
  const widgetId = widget.widget_id.slice(0, lastIndex);

  const { data: widgetAnalysisResult } = useGetWidgetAnalysisConfig(
    mapPostWidgetAnalysisConfigPayload(widget, filters[widgetId] ?? [])
  );

  const rawData = useMemo(() => {
    return widgetAnalysisResult?.data?.data?.slice(
      0,
      widget.configuration.dimension_values_shown
    );
  }, [widgetAnalysisResult, widget]);

  return {
    rawData
  };
}
